import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
const defaultTag = 'h1';
function PageHeader({ children, title, tag, right, className, ...tagProperties }) {
    const HeaderElement = tag ?? defaultTag;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "my-12",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('flex justify-between', className),
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(HeaderElement, {
                        ...tagProperties,
                        className: "text-xl font-semibold text-primary md:text-3xl",
                        children: title
                    }),
                    right && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "flex flex-col items-center justify-center",
                        children: right
                    })
                ]
            }),
            children && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "mt-2 text-sm",
                children: children
            })
        ]
    });
}
export { PageHeader };

//# sourceMappingURL=index.js.map